import { createSelector } from '@reduxjs/toolkit'

import { RootState } from 'app/store'
import {
  HOME_CLOUD_SOFTWARE_HISTORY_REDUCER_NAME,
  HOME_REDUCER_NAME,
  HOME_SOFTWARE_REDUCER_NAME,
} from 'features/home/consts'
import { selectedHomeSelector } from 'features/home/selectors'
import { checkSoftwareUpdateInProgress } from '../utils'

export const cloudSoftwareHistoryDataSelector = (state: RootState) =>
  state[HOME_REDUCER_NAME][HOME_SOFTWARE_REDUCER_NAME][
    HOME_CLOUD_SOFTWARE_HISTORY_REDUCER_NAME
  ]

export const cloudSoftwareHistorySelector = createSelector(
  cloudSoftwareHistoryDataSelector,
  (cloudSoftwareHistoryData) => cloudSoftwareHistoryData?.cloudSoftwareHistory
)

export const allCloudSoftwareHistoryFetchedSelector = createSelector(
  cloudSoftwareHistoryDataSelector,
  (cloudSoftwareHistoryData) =>
    cloudSoftwareHistoryData?.allCloudSoftwareHistoryFetched
)
export const allCloudSoftwareHistoryNextSelector = createSelector(
  cloudSoftwareHistoryDataSelector,
  (cloudSoftwareHistoryData) => cloudSoftwareHistoryData?.next
)

export const selectSoftwareUpdatesInProgress = createSelector(
  cloudSoftwareHistorySelector,
  (softwareHistory) => {
    return softwareHistory.filter(checkSoftwareUpdateInProgress)
  }
)

export const selectSoftwareUpdateInProgress = createSelector(
  cloudSoftwareHistorySelector,
  (softwareHistory) => {
    return softwareHistory.some(checkSoftwareUpdateInProgress)
  }
)

export const selectedHomeConfigAccessEnabledSelector = createSelector(
  selectedHomeSelector.data,
  (selectedHome) => {
    if (selectedHome) {
      const configAccessExpires = selectedHome.configAccessExpires || 0
      return configAccessExpires >= Date.now()
    }
  }
)
